import type { Editor, EditorStateSnapshot } from '@tiptap/react';
import { useEditorState } from '@tiptap/react';

export function useIsEditorReadonly(editor: Editor | null | undefined): boolean {
    return (
        useEditorState({
            editor: editor ?? null,
            selector: (ctx: EditorStateSnapshot<Editor | null>) => ctx.editor?.isEditable === false,
        }) ?? false
    );
}
